import styled from 'styled-components';

const FooterStyle = styled.footer`
	--footerPadT: 100px;
	--footerPadB: var(--sp6x);
	--footerPadLR: var(--sp6x);
	--footerInnerWrapperRadius: var(--sp4x);
	--footerInnerWrapperPadT: var(--sp13x);
	--footerInnerWrapperPadB: var(--sp8x);
	--footerInnerWrapperPadLR: var(--sp6x);
	--footerLine: 2px;
	--footerLeftContentWidth: var(--sp120x);
	--footerContentGap: var(--sp30x);

	--footerIconWrapSize: var(--sp9x);
	--footerIconsGap: var(--sp3x);
	--footerRightContentGap: var(--sp4x);
	--footerColLeftCenterItemsGap: var(--sp4x);

	--footerInnerBottomWrapperMTop: var(--sp9x);
	--lottieWidth: var(--sp46x);
	--lottieHeight: var(--sp26x);

	background-color: var(--green1000);
	overflow: hidden;
	padding: var(--footerPadT) var(--footerPadLR) var(--footerPadB);

	.footer-inner-wrapper {
		border-radius: var(--footerInnerWrapperRadius);
		background-color: var(--yellow1000);
		padding: var(--footerInnerWrapperPadT) var(--footerInnerWrapperPadLR) var(--footerInnerWrapperPadB);
		overflow: hidden;
		transform: translateY(150px) rotateZ(-5deg);
		will-change: transform;
	}

	.footer-inner-top-wrapper {
		display: flex;
		gap: var(--footerContentGap);
	}

	.footer-left-content {
		width: var(--footerLeftContentWidth);
	}

	.footer-left-text2-link {
		display: inline-flex;
		width: fit-content;
	}

	.footer-right-content {
		display: flex;
		flex: 1;
		justify-content: space-between;
		gap: var(--footerColLeftCenterItemsGap);
	}

	.content-col-left,
	.content-col-center {
		width: calc((100% - var(--footerIconWrapSize)) / 2);
	}

	.content-col-left-inner,
	.content-col-center-inner {
		display: flex;
		flex-direction: column;
		gap: var(--footerColLeftCenterItemsGap);
	}

	.footer-menu-item-link {
		display: inline-flex;
		width: fit-content;
	}

	.footer-icons-wrapper {
		display: flex;
		flex-direction: column;
		gap: var(--footerIconsGap);
	}

	.icon-wrap {
		display: flex;
		justify-content: center;
		align-items: center;
		width: var(--footerIconWrapSize);
		height: var(--footerIconWrapSize);
		border-radius: 50%;
		background-color: var(--green1000);

		svg {
			width: var(--h6);
			height: var(--h6);
			will-change: transform;
			transition: transform var(--trTime) ease-out;
		}

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					svg {
						transform: scale(1.3);
					}
				}
			}
		}
	}

	.footer-inner-bottom-wrapper {
		display: flex;
		gap: var(--footerContentGap);
		/* margin-top: var(--footerInnerBottomWrapperMTop); */

		.footer-left-content {
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			gap: var(--sp2x);

			.text-underline-animation {
				&::before,
				&::after {
					height: var(--footerLine);
				}
			}
		}

		.footer-right-content {
			justify-content: unset;
			gap: unset;
			align-items: flex-end;

			.content-col-left {
				padding-right: var(--footerRightContentGap);
			}

			.content-col-center {
				width: unset;
				display: flex;
				flex: 1;
				justify-content: space-between;
				gap: var(--footerRightContentGap);
			}
		}
	}

	.lottie-container {
		display: flex;
		position: relative;
		width: var(--lottieWidth) !important;
		height: var(--lottieHeight) !important;

		margin-bottom: calc(var(--lottieHeight) / 4);

		.lottie-wrap {
			display: flex;
		}

		.lottie-first {
			width: 100%;
		}

		.un-active-lottie {
			opacity: 0;
			transition: 0.1s ease-out;
		}

		.lottie-second {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
		}

		svg {
			height: auto !important;
		}
	}

	.office-name-link,
	.terms-of-use-link,
	.privacy-policy-link {
		display: inline-flex;
		width: fit-content;
	}

	.terms-of-use-link,
	.privacy-policy-link,
	.footer-office-name {
		white-space: nowrap;
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--footerPadT: var(--sp10x);
		--footerPadB: var(--sp6x);
		--footerPadLR: var(--sp5x);
		--footerInnerWrapperRadius: var(--sp4x);
		--footerInnerWrapperPadT: var(--sp8x);
		--footerInnerWrapperPadB: 44px;
		--footerInnerWrapperPadLR: var(--sp6x);
		--footerLeftContentWidth: var(--sp86x);
		--footerContentGap: var(--sp23x);

		--footerIconWrapSize: var(--sp8x);
		--footerIconsGap: var(--sp3x);
		--footerRightContentGap: var(--sp4x);
		--footerColLeftCenterItemsGap: var(--sp3x);

		--footerInnerBottomWrapperMTop: var(--sp2-5x);
		--lottieWidth: var(--sp31x);
		--lottieHeight: var(--sp17x);
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--footerPadT: 60px;
		--footerPadB: var(--sp6x);
		--footerPadLR: var(--sp5x);
		--footerInnerWrapperRadius: var(--sp4x);
		--footerInnerWrapperPadT: var(--sp7x);
		--footerInnerWrapperPadB: var(--sp4x);
		--footerInnerWrapperPadLR: var(--sp5x);

		--footerLeftContentWidth: var(--sp84x);
		--footerContentGap: var(--sp15x);

		--footerIconWrapSize: var(--sp7x);
		--footerIconsGap: var(--sp3x);
		--footerRightContentGap: var(--sp3x);
		--footerColLeftCenterItemsGap: var(--sp3x);

		--footerInnerBottomWrapperMTop: 60px;
		--lottieWidth: var(--sp31x);
		--lottieHeight: var(--sp17x);

		.icon-wrap {
			svg {
				width: var(--h5);
				height: var(--h5);
			}
		}
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--footerPadT: 52px;
		--footerPadB: var(--sp5x);
		--footerPadLR: var(--sp4x);
		--footerInnerWrapperRadius: var(--sp3x);
		--footerInnerWrapperPadT: var(--sp6x);
		--footerInnerWrapperPadB: var(--sp3x);
		--footerInnerWrapperPadLR: var(--sp4x);

		--footerLeftContentWidth: var(--sp77x);
		--footerContentGap: var(--sp12x);

		--footerIconWrapSize: var(--sp7x);
		--footerIconsGap: var(--sp3x);
		--footerRightContentGap: var(--sp3x);
		--footerColLeftCenterItemsGap: var(--sp2-5x);

		--footerInnerBottomWrapperMTop: var(--sp10x);
		--lottieWidth: var(--sp31x);
		--lottieHeight: var(--sp17x);

		.icon-wrap {
			svg {
				width: var(--h4);
				height: var(--h4);
			}
		}
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--footerPadT: 44px;
		--footerPadB: var(--sp3x);
		--footerPadLR: var(--sp4x);
		--footerInnerWrapperRadius: var(--sp2x);
		--footerInnerWrapperPadT: var(--sp5x);
		--footerInnerWrapperPadB: var(--sp3x);
		--footerInnerWrapperPadLR: var(--sp3x);

		--footerLeftContentWidth: var(--sp58x);
		--footerContentGap: var(--sp9x);

		--footerIconWrapSize: var(--sp6x);
		--footerIconsGap: var(--sp1-5x);
		--footerRightContentGap: var(--sp2-5x);
		--footerColLeftCenterItemsGap: var(--sp2-5x);

		--footerInnerBottomWrapperMTop: var(--sp5x);
		--lottieWidth: var(--sp28x);
		--lottieHeight: var(--sp15x);
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--footerPadT: 44px;
		--footerPadB: var(--sp3x);
		--footerPadLR: var(--sp4x);
		--footerInnerWrapperRadius: var(--sp2x);
		--footerInnerWrapperPadT: var(--sp5x);
		--footerInnerWrapperPadB: var(--sp3x);
		--footerInnerWrapperPadLR: var(--sp3x);

		--footerLeftContentWidth: var(--sp46x);
		--footerContentGap: var(--sp9x);
		--footerIconWrapSize: var(--sp5x);
		--footerIconsGap: var(--sp1-5x);
		--footerRightContentGap: var(--sp2-5x);
		--footerColLeftCenterItemsGap: var(--sp2-5x);

		--footerInnerBottomWrapperMTop: var(--sp5x);
		--lottieWidth: var(--sp22x);
		--lottieHeight: var(--sp12x);
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--footerPadT: 44px;
		--footerPadB: var(--sp3x);
		--footerPadLR: var(--sp3x);
		--footerInnerWrapperRadius: var(--sp2x);
		--footerInnerWrapperPadT: var(--sp4x);
		--footerInnerWrapperPadB: var(--sp2x);
		--footerInnerWrapperPadLR: var(--sp3x);

		--footerLeftContentWidth: var(--sp37x);
		--footerContentGap: var(--sp3x);

		--footerIconWrapSize: var(--sp5x);
		--footerIconsGap: var(--sp1x);
		--footerRightContentGap: var(--sp2x);
		--footerColLeftCenterItemsGap: var(--sp2x);

		--footerInnerBottomWrapperMTop: var(--sp5x);
		--lottieWidth: var(--sp20x);
		--lottieHeight: var(--sp11x);
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--footerPadT: var(--sp4x);
		--footerPadB: var(--sp2x);
		--footerPadLR: var(--sp2x);
		--footerInnerWrapperRadius: var(--sp2x);
		--footerInnerWrapperPadT: var(--sp4x);
		--footerInnerWrapperPadB: var(--sp4x);
		--footerInnerWrapperPadLR: var(--sp2x);
		--footerLine: 1px;
		--footerLeftContentWidth: 100%;
		--footerContentGap: var(--sp4x);

		--footerIconWrapSize: var(--sp5x);
		--footerIconsGap: var(--sp1-5x);
		--footerRightContentGap: var(--sp1x);
		--footerColLeftCenterItemsGap: var(--sp1-5x);

		--footerInnerBottomWrapperMTop: var(--sp3x);
		--lottieWidth: 100%;
		/* --lottieHeight: var(--sp10x); */
		--lottieHeight: 100%;

		.lottie-first,
		.lottie-second {
			display: flex;
			align-items: flex-end;
		}

		.footer-inner-top-wrapper {
			flex-direction: column;

			.footer-right-content {
				flex-wrap: wrap;

				.content-col-right {
					margin-top: var(--sp3x);
				}

				.footer-icons-wrapper {
					flex-direction: row;
				}
			}
		}

		.footer-inner-bottom-wrapper {
			--footerContentGap: var(--sp1x);

			margin-top: var(--footerInnerBottomWrapperMTop);

			.footer-left-content {
				width: calc((100% - var(--footerColLeftCenterItemsGap)) / 2);
				flex-direction: column;
				justify-content: unset;
				align-items: unset;
			}

			.footer-right-content {
				width: calc((100% - var(--footerColLeftCenterItemsGap)) / 2);
				align-items: unset;
			}

			.content-col-center {
				display: flex;
				flex-direction: column;
				gap: var(--sp2x);
			}
		}

		.content-col-left,
		.content-col-center {
			width: calc((100% - var(--footerColLeftCenterItemsGap)) / 2);
		}

		.content-col-right {
			width: 100%;
		}

		.lottie-container {
			margin-bottom: 0;
		}
	}
`;

export default FooterStyle;
